// extracted by mini-css-extract-plugin
export default {"relativeContainer":"NjQ71C","container":"ZylKKv"};